import { trackerTypesEnum } from "helpers/enums";
import { buildQuery, containsQuery, OdataFilters, queryCollection, queryParams } from "helpers/reqparams";
import { alertRequest, body, downloadFileHandler, request } from "services/request";

const resource = "api/trackers";
const trackersQuery = {
    filter: { type: { ne: trackerTypesEnum.Mobile } },
    orderBy: ["id desc"],
};

const trackersInfoQuery = {
    orderBy: ["percentOfCarsWithoutCoordinatesIn1Hour asc"],
};

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter, ...trackersQuery.filter } });
    return request(`${resource}/get${query}`, { method: "GET" }, { countInHeaders: true });
};

const getListExcel = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter, ...trackersQuery.filter } });
    return request(`${resource}/getListExcel?${query}`, { method: "GET" }, { withoutMiddleware: true }).then((res) =>
        downloadFileHandler(res, "Трекеры.xlsx"),
    );
};

const getItem = (params: { id: number }) => {
    const query = params.id;
    return request(`${resource}/get/${query}`, { method: "GET" });
};

const list = (params: {}) => request(`${resource}/get${containsQuery(params, trackersQuery)}`, { method: "GET" });
const deviceNumbersList = (params: {}) =>
    request(`${resource}/getDeviceNumbersList${containsQuery(params, trackersQuery)}`, { method: "GET" });
const apply = (params: {}) => alertRequest(`${resource}/apply`, body(params));
const upload = (params: {}) => alertRequest(`${resource}/upload`, params);
const delItem = (params: {}) => alertRequest(`${resource}/delete`, body(params));
const deleteEmulatedSegment = (params: {}) => alertRequest(`${resource}/deleteEmulatedSegment`, body(params));
const attach = (params: {}) => alertRequest(`${resource}/attach`, body(params));
const getLastAxisLoadValue = (id: string) =>
    request(`${resource}/getLastAxisLoadValue?trackerId=${id}`, { method: "GET" });
const getOdometerValues = (params: {}) =>
    request(`${resource}/getOdometerValues${queryParams(params)}`, { method: "GET" });
const setLastCorrectOdometerValue = (params: {}) =>
    alertRequest(`${resource}/setLastCorrectOdometerValue`, body(params));

const getAxisLoadValues = (trackerId: number, filter: {}) => {
    const query = buildQuery({ filter }).substr(1);
    return request(`${resource}/getAxisLoadValues?trackerId=${trackerId}&${query}`, { method: "GET" });
};

const getTrackersInfo = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter, ...trackersInfoQuery });
    return request(`${resource}/getTrackersInfo${query}`, { method: "GET" }, { countInHeaders: true });
};

export {
    index,
    list,
    apply,
    getItem,
    delItem,
    attach,
    upload,
    deviceNumbersList,
    getLastAxisLoadValue,
    getAxisLoadValues,
    getTrackersInfo,
    deleteEmulatedSegment,
    getListExcel,
    getOdometerValues,
    setLastCorrectOdometerValue,
};
